<mat-sidenav-container (backdropClick)="closeBasket()">
    <mat-sidenav position="end" [opened]="basketOpened" disableClose *ngIf="isOnline">
        <router-outlet name="basket"></router-outlet>
    </mat-sidenav>
    <mat-sidenav-content id="main">
        <app-tool-bar></app-tool-bar>
        <app-breadcrumb class="is-mobile"></app-breadcrumb>
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>
<app-footer></app-footer>